.layout {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: var(--tuna-spacing-4);
  padding: var(--tuna-spacing-4);
  width: 100%;
  height: 100%;
}

.wheel {
  min-width: 0;
}

@media (max-width: 768px) {
  .layout {
    grid-template-columns: 1fr;
  }
}
